goog.provide("shadow.js.shim.module$date_fns$lastDayOfYear$default");
shadow.js.shim.module$date_fns$lastDayOfYear$default = shadow.js.require(129, {})["default"];
